<template>
  <Modal v-model="show" title="添加代码库" :closable="false" :mask-closable="false" width="600px">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="120">
      <FormItem prop="name" label="仓库名">
        <Input type="text" v-model.trim="formData.name" placeholder="请输入" />
      </FormItem>
      <FormItem prop="visibility" label="仓库类型">
        <RadioGroup v-model="formData.visibility">
          <Radio label="true">公开</Radio>
          <Radio label="false">私有</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <template #footer>
      <Button type="default" @click="show = false">取消</Button>
      <Button type="primary" @click="handleSubmit('formData')" :loading="loading">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { Form, FormItem, Input, Modal, Button, RadioGroup, Radio } from 'view-design'
import { checklibName } from '@/utils/check'
export default {
  components: { Form, FormItem, Input, Modal, Button, RadioGroup, Radio },
  props: {
    codeVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    project_id: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      formData: {
        name: '',
        visibility: 'true'
      },
      loading: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入仓库名',
            trigger: 'blur'
          },
          {
            required: true,
            validator: checklibName,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handleOk()
        }
      })
    },
    async handleOk() {
      const params = {
        uriCode: 'API040',
        id: +this.project_id,
        name: this.formData.name,
        visibility: this.formData.visibility === 'true' ? true : false
      }

      try {
        this.loading = true
        await this.$fetch(params)
      } finally {
        this.loading = false
        this.show = false
        this.$emit('ok')
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.codeVisible
      },
      set(val) {
        this.$emit('update:codeVisible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.$refs['formData'].resetFields()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.w100 {
  width: 100% !important;
}
</style>
